import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SduiNavigationService {
  constructor(private router: Router) {}

  navigateBySduiUrl(url: string): boolean {
    if (!url) return false;

    if (url.includes('timeline/')) {
      const postId = url.split('timeline/')[1];
      this.router.navigate(['comunidade', 'postagem', postId], { queryParams: { from: 'sdui' } });
      return true;
    }

    if (url.includes('live/')) {
      const liveId = url.split('live/')[1];
      this.router.navigate(['comunidade', 'postagem', 'live', liveId], { queryParams: { from: 'sdui' } });
      return true;
    }

    if (url.includes('lesson/')) {
      const lessonId = url.split('lesson/')[1];
      const productId = url.includes('product/') ? url.split('product/')[1].split('/')[0] : null;
      if (productId) {
        this.router.navigate(['produtos', productId, 'aula', lessonId], { queryParams: { from: 'sdui' } });
        return true;
      }
    }

    if (url.includes('product/')) {
      const productId = url.split('product/')[1];
      this.router.navigate(['produtos', productId], { queryParams: { from: 'sdui' } });
      return true;
    }

    if (url.includes('posts/')) {
      const postId = url.split('posts/')[1];
      this.router.navigate(['comunidade', 'postagem', postId], { queryParams: { from: 'sdui' } });
      return true;
    }

    const profileRoutes = new Map<string, string[]>([
      ['my-purchases', ['perfil', 'compras']],
      ['my-annotations', ['perfil', 'meu-caderno']],
      ['my-list', ['perfil', 'minha-lista']],
      ['my-certificates', ['perfil', 'certificados']],
      ['my-subscriptions', ['perfil', 'assinaturas']],
      ['edit-profile', ['perfil', 'editar']],
      ['ranking/rules', ['perfil', 'ranking', 'regras']],
      ['ranking', ['perfil', 'ranking']],
      ['logout', ['logout']],
    ]);

    for (const [key, route] of profileRoutes.entries()) {
      if (url.includes(key)) {
        this.router.navigate(route, { queryParams: { from: 'sdui' } });
        return true;
      }
    }

    return false; // nenhum dos casos foi tratado
  }
}
